import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiFilter } from "react-icons/fi";
import { TASK_TITLE, DEFAULT_STATUS_OPTIONS,ERROR } from "./constant";
import { getAllUsers } from "../../Services/UserService";
import { ADD_TASK } from "../../routes";
import UserTask from "./Component/UserTask";
import CommonFilter from "../../Components/Common/CommonFilter";
import { GET_ALL_PAGINATION } from "../../Constants/Strings";
import toast from "react-hot-toast";
import { extractErrorMessage } from "../../Utils/extractErrorMessage";

const TaskListPage = () => {
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    status: "",
    user: "",
    date: "",
    assignee: "",
  });

  const [tempFilters, setTempFilters] = useState(filters);
  const [showFilter, setShowFilter] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = (await getAllUsers(GET_ALL_PAGINATION)).data.results;
        setUsers(res);
      } catch (err) {
        const msg = extractErrorMessage(err) || ERROR.USER_FETCH_FAILED;
        toast.error(msg);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleApply = () => {
    setFilters(tempFilters);
    setShowFilter(false);
  };

  const handleClear = () => {
    const cleared = { status: "", user: "", date: "", assignee: "" };
    setTempFilters(cleared);
  };

  const handleCancel = () => {
    setTempFilters(filters);
    setShowFilter(false);
  };

  return (
    <div className="px-4 py-4 relative">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-primary">{TASK_TITLE}</h2>
        <div className="flex gap-2 items-center">
          <button
            className="px-4 py-2 rounded bg-primary hover:bg-green-600 text-white font-bold shadow-lg flex items-center gap-1"
            onClick={() => {
              setTempFilters(filters);
              setShowFilter(true);
            }}
          >
            <FiFilter className="text-xl" />
          </button>

          <button
            className="px-4 py-2 rounded bg-primary hover:bg-green-600 text-white font-bold shadow-lg"
            onClick={() => navigate(ADD_TASK)}
          >
            Add Task
          </button>
        </div>
      </div>

      {/* Task List */}
      <UserTask filters={filters} />

      {/* Filter Modal */}
      {showFilter && (
        <CommonFilter
          title="Task Filter"
          tempFilters={tempFilters}
          setTempFilters={setTempFilters}
          onApply={handleApply}
          onClear={handleClear}
          onCancel={handleCancel}
          statusOptions={DEFAULT_STATUS_OPTIONS}
          userOptions={users}
          assignee={true}
        />
      )}
    </div>
  );
};

export default TaskListPage;
